(function () {
  var root = document.querySelector('[data-afq]');
  if (!root) { return; }

  var CAT = [];
  try { CAT = JSON.parse(document.getElementById('afq-catalogo').textContent); } catch (e) { return; }

  var Q = [
    { key: 'pele', n: 'Como você definiria sua pele hoje?',
      help: 'Se estiver em dúvida, escolha a última opção — o resultado continua válido.',
      opts: [
        { v: 'Seca', l: 'Seca', d: 'Repuxa depois da limpeza, descama em algumas áreas' },
        { v: 'Oleosa', l: 'Oleosa', d: 'Brilho ao longo do dia, principalmente na zona T' },
        { v: 'Mista', l: 'Mista', d: 'Oleosa na zona T e normal ou seca no resto' },
        { v: 'Sensível', l: 'Sensível e reativa', d: 'Arde, coça ou avermelha com ativos mais fortes' },
        { v: 'Madura', l: 'Madura', d: 'Perda de firmeza e densidade é o que mais incomoda' },
        { v: 'Acneica', l: 'Acneica', d: 'Espinhas com frequência, não só eventuais' },
        { v: '', l: 'Não sei dizer', d: 'Prefiro uma indicação que sirva a qualquer pele' }
      ] },
    { key: 'need', n: 'Qual a sua maior preocupação agora?',
      help: 'Uma só — a rotina inteira é montada em torno dela.',
      opts: [
        { v: 'Manchas e uniformidade', l: 'Manchas e tom desigual' },
        { v: 'Linhas e rugas|Firmeza e flacidez', l: 'Linhas finas e perda de firmeza' },
        { v: 'Oleosidade e poros', l: 'Oleosidade e poros dilatados' },
        { v: 'Acne e imperfeições', l: 'Espinhas e imperfeições' },
        { v: 'Ressecamento e desconforto', l: 'Ressecamento e repuxamento' },
        { v: 'Sensibilidade e vermelhidão|Barreira danificada', l: 'Vermelhidão e barreira fragilizada' },
        { v: 'Opacidade e viço', l: 'Pele opaca, sem viço' },
        { v: '', l: 'Só quero uma rotina segura' }
      ] },
    { key: 'proc', n: 'Você faz procedimentos estéticos?',
      help: 'Peeling, laser, microagulhamento, ultrassom. Isso muda quais ativos entram na rotina de casa.',
      opts: [
        { v: '1', l: 'Sim, com alguma regularidade' },
        { v: '', l: 'Não' }
      ] },
    { key: 'nivel', n: 'Como você quer montar a rotina?',
      help: 'Dá para começar pequeno e crescer depois — nenhuma das três está errada.',
      opts: [
        { v: 'essencial', l: 'Essencial', d: 'Três passos: limpeza, um tratamento e hidratação' },
        { v: 'completa', l: 'Completa', d: 'Preparo, tratamento de dia e de noite, hidratação e complemento' },
        { v: 'avancada', l: 'Avançada', d: 'A rotina completa, priorizando a linha Biotech' }
      ] },
    { key: 'labial', n: 'Quer incluir um cuidado para os lábios?',
      help: '',
      opts: [{ v: '1', l: 'Sim' }, { v: '', l: 'Não, obrigado' }] }
  ];

  var A = {};
  var i = 0;

  function money(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }

  function needs() { return (A.need || '').split('|').filter(Boolean); }

  function pool() {
    var sens = A.pele === 'Sensível';
    return CAT.filter(function (p) {
      /* pele reativa: so entra o que declara Sensivel no metacampo.
         nenhuma lista de excecao escrita a mao — o dado decide. */
      if (sens && p.pele.indexOf('Sensível') < 0) { return false; }
      return true;
    });
  }

  function score(p) {
    var s = 0;
    if (A.pele) {
      if (p.pele.indexOf(A.pele) >= 0) { s += 4; }
      else if (p.pele.indexOf('Todos os tipos') >= 0) { s += 1; }
      else { s -= 5; }
    } else if (p.pele.indexOf('Todos os tipos') >= 0) { s += 1; }

    needs().forEach(function (n) { if (p.need.indexOf(n) >= 0) { s += 5; } });

    if (A.proc && p.mom.indexOf('Pós-procedimento') >= 0) { s += 3; }
    if (A.nivel === 'avancada' && p.linha === 'Biotech') { s += 4; }
    if (A.nivel === 'essencial' && p.linha !== 'Biotech') { s += 1; }
    return s;
  }

  /* min: nota minima para o produto poder ser indicado.
     passos obrigatorios aceitam 0; passos opcionais exigem nota positiva,
     senao o quiz recomenda por falta de alternativa — foi assim que o tonico
     de acido glicolico apareceu para pele seca no primeiro teste. */
  function best(list, step, momento, skip, min) {
    var floor = (typeof min === 'number') ? min : 0;
    var c = list.filter(function (p) {
      if (p.step !== step) { return false; }
      if (skip && skip.indexOf(p.handle) >= 0) { return false; }
      if (momento && p.mom.indexOf(momento) < 0) { return false; }
      return score(p) >= floor;
    });
    if (!c.length) { return null; }
    c.sort(function (a, b) {
      var d = score(b) - score(a);
      if (d !== 0) { return d; }
      return a.price - b.price; /* empate: o mais barato, para o quiz nao empurrar ticket */
    });
    return c[0];
  }

  function why(p) {
    var bits = [];
    needs().forEach(function (n) { if (p.need.indexOf(n) >= 0) { bits.push(n.toLowerCase()); } });
    if (A.pele && p.pele.indexOf(A.pele) >= 0) { bits.push('indicado para pele ' + A.pele.toLowerCase()); }
    if (A.proc && p.mom.indexOf('Pós-procedimento') >= 0) { bits.push('liberado para pós-procedimento'); }
    if (!bits.length) { bits.push('serve a todos os tipos de pele'); }
    return bits.slice(0, 3).join(' · ');
  }

  function build() {
    var P = pool();
    var out = [];
    var used = [];
    function push(label, p) {
      if (!p) { return; }
      used.push(p.handle);
      out.push({ label: label, p: p });
    }
    function temTratar() {
      return out.some(function (o) { return o.label.indexOf('Tratar') >= 0; });
    }

    push('1 · Limpar', best(P, '1'));

    if (A.nivel !== 'essencial') {
      push('2 · Tonificar', best(P, '2', null, used, 1));
    }

    if (A.nivel === 'essencial') {
      push('3 · Tratar', best(P, '3', null, used));
    } else {
      push('3 · Tratar — manhã', best(P, '3', 'Manhã', used));
      push('3 · Tratar — noite', best(P, '3', 'Noite', used));
      if (!temTratar()) { push('3 · Tratar', best(P, '3', null, used)); }
    }

    push('4 · Hidratar', best(P, '4', null, used));

    if (A.nivel === 'completa' || A.nivel === 'avancada') {
      push('Complementar', best(P.filter(function (p) { return p.need.indexOf('Lábios') < 0; }), 'c', null, used, 1));
    }

    if (A.labial) {
      var lip = CAT.filter(function (p) { return p.need.indexOf('Lábios') >= 0; })[0];
      if (lip) { push('Lábios', lip); }
    }

    return out;
  }

  function renderQ() {
    var q = Q[i];
    var h = '<div class="afq-prog">';
    for (var k = 0; k < Q.length; k++) { h += '<i class="' + (k <= i ? 'on' : '') + '"></i>'; }
    h += '</div><span class="afq-qn">Pergunta ' + (i + 1) + ' de ' + Q.length + '</span><h2>' + esc(q.n) + '</h2>';
    if (q.help) { h += '<p class="afq-help">' + esc(q.help) + '</p>'; }
    h += '<div class="afq-opts">';
    q.opts.forEach(function (o) {
      var on = A.hasOwnProperty(q.key) && (A[q.key] || '') === o.v;
      h += '<button type="button" class="afq-opt" aria-pressed="' + (on ? 'true' : 'false') + '" data-v="' + esc(o.v) + '">' +
        '<span class="afq-mark"></span><span>' + esc(o.l) + (o.d ? '<em>' + esc(o.d) + '</em>' : '') + '</span></button>';
    });
    h += '</div><div class="afq-nav">';
    if (i > 0) { h += '<button type="button" class="afq-btn afq-btn--ghost" data-back>Voltar</button>'; }
    h += '</div>';
    root.innerHTML = h;

    root.querySelectorAll('.afq-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        A[q.key] = b.getAttribute('data-v');
        i++;
        if (i >= Q.length) { renderR(); } else { renderQ(); }
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var bk = root.querySelector('[data-back]');
    if (bk) { bk.addEventListener('click', function () { i--; renderQ(); }); }
  }

  function renderR() {
    var res = build();
    var chips = [];
    if (A.pele) { chips.push('Pele ' + A.pele.toLowerCase()); }
    needs().forEach(function (n) { chips.push(n); });
    if (A.proc) { chips.push('Faz procedimentos'); }
    chips.push('Rotina ' + (A.nivel === 'essencial' ? 'essencial' : A.nivel === 'avancada' ? 'avançada' : 'completa'));

    var h = '<div class="afq-res-head"><span class="afq-qn">Seu resultado</span>' +
      '<h2>' + (res.length ? 'Uma rotina de ' + res.length + (res.length === 1 ? ' passo' : ' passos') : 'Não consegui montar uma rotina') + '</h2>' +
      '<p class="afq-help">Cada item foi escolhido pelos dados do próprio produto — tipo de pele, necessidade e momento de uso declarados na ficha. Desmarque o que não quiser levar.</p>' +
      '<div class="afq-chips">' + chips.map(function (c) { return '<span class="afq-chip">' + esc(c) + '</span>'; }).join('') + '</div></div>';

    res.forEach(function (r) {
      var p = r.p;
      h += '<div class="afq-step">' +
        (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<span class="ph"></span>') +
        '<div class="afq-body"><span class="afq-lbl">' + esc(r.label) + '</span>' +
        '<h3><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
        '<p class="afq-why">' + esc(why(p)) + '</p></div>' +
        '<div class="afq-side"><span class="afq-price">' + money(p.price) + '</span>' +
        '<label class="afq-inc"><input type="checkbox" checked data-vid="' + p.vid + '" data-price="' + p.price + '"> levar</label>' +
        '</div></div>';
    });

    h += '<div class="afq-total"><span class="t"><small>Total selecionado</small><b data-total>—</b></span>' +
      '<span style="display:flex;gap:12px;flex-wrap:wrap">' +
      '<button type="button" class="afq-btn afq-btn--ghost" data-again>Refazer o quiz</button>' +
      '<button type="button" class="afq-btn" data-cart>Adicionar à sacola</button></span></div>' +
      '<p class="afq-msg" data-msg></p>' +
      '<p class="afq-note">Esta é uma sugestão de rotina cosmética montada a partir das respostas, e não um diagnóstico. Nenhum produto Artefoá substitui avaliação dermatológica. Quem faz procedimentos deve reintroduzir ativos apenas após liberação do profissional responsável. Protetor solar de alto FPS é parte de qualquer rotina e ainda não faz parte do nosso catálogo.</p>';

    root.innerHTML = h;

    var boxes = Array.prototype.slice.call(root.querySelectorAll('.afq-inc input'));
    var totalEl = root.querySelector('[data-total]');
    function total() {
      var t = 0;
      boxes.forEach(function (b) { if (b.checked) { t += parseInt(b.getAttribute('data-price'), 10); } });
      totalEl.textContent = money(t);
      return t;
    }
    boxes.forEach(function (b) { b.addEventListener('change', total); });
    total();

    root.querySelector('[data-again]').addEventListener('click', function () {
      A = {}; i = 0; renderQ(); root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    root.querySelector('[data-cart]').addEventListener('click', function () {
      var msg = root.querySelector('[data-msg]');
      var items = boxes.filter(function (b) { return b.checked; })
        .map(function (b) { return { id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1 }; });
      if (!items.length) { msg.textContent = 'Selecione ao menos um produto.'; return; }
      msg.textContent = 'Adicionando…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) { throw new Error('falhou'); }
        window.location.href = '/cart';
      }).catch(function () {
        msg.textContent = 'Não consegui adicionar agora. Tente de novo ou abra os produtos um a um.';
      });
    });
  }

  renderQ();
})();
